import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { Observable } from "rxjs";

import { AuthService } from "../services/auth.service";
import { Store } from "@ngrx/store";

@Injectable()
export class JwtCmsInterceptor implements HttpInterceptor {
  apiUrl: string;
  constructor(
    private authenticationService: AuthService,
    private store: Store<{ config: any }>
  ) {
    store.select("config").subscribe((res) => {
      this.apiUrl = res.apiUrl;
    });
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add auth header with jwt if user is logged in and request is to api url
    const user = this.authenticationService.userValue;
    const isLoggedIn = user && user?.data?.token;
    const isApiUrl = request.url.startsWith(this.apiUrl);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: {
          "X-Locale": localStorage.getItem("cmsLanguage") || "en",
          "X-Locale-Timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
          Authorization: `Bearer ${user?.data?.token}`,
          "ngrok-skip-browser-warning": "true",
        },
      });
    }

    return next.handle(request);
  }
}
